import { getLink } from '../../../utils/utils';

import vsevolodGarŝin from './vsevolod_garŝin';

const felikx_krivin = {
	itemName: {
		esp: 'Feliks Krivin. Duonfabeloj (mikrofabloj).'
	}
}
const tradukita_prozo = [
	vsevolodGarŝin,
	{
		itemlink: getLink(felikx_krivin.itemName.esp),
		esp: {
			itemName: felikx_krivin.itemName.esp,
			isReactComponent: true,
			itemContentName: 'TProzoKrivinContent'
		}
	},
];

export default tradukita_prozo;